export default "__VITE_ASSET__557511be__"